import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints, layout }: ITheme) => ({
    root: {
      background: `linear-gradient(to bottom, ${layout.background}, ${layout.background})`,
      backgroundPosition: '0 0',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      padding: '20px 40px',
      marginBottom: 80,

      '&.partialBg': {
        backgroundSize: '100% 70%',
      },

      [mediaQuery(breakpoints.tablet)]: {
        padding: '20px 24px',
        marginBottom: 60,
      },
    },
    banner: {
      maxWidth: layout.maxWidth,
      margin: 'auto',
      padding: '28px 32px',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '0px',
      },
    },
    bannerContent: {
      maxWidth: '894px',
      margin: 'auto',
      display: 'flex',
      gap: 42,
      marginBottom: 48,
      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column-reverse',
        gap: 24,
        marginBottom: 24,
      },
    },
    imgContainer: {
      margin: '0px',
      display: 'flex',
      [mediaQuery(breakpoints.tablet)]: {
        '& img': {
          marginLeft: 'auto',
        },
      },

      '& img': {
        maxWidth: '100%',
        verticalAlign: 'top',
        display: 'inline-block',
      },
    },
    heading: {
      flex: 1,
      fontSize: '42px',
      lineHeight: '50px',
      color: 'var(--x-accent-2-1)',
      fontWeight: FontWeight.Medium,
      margin: '40px 0px',
      [mediaQuery(breakpoints.tablet)]: {
        margin: '0px',
        fontSize: '36px',
        lineHeight: '42px',
      },
    },
    content: {
      maxWidth: '894px',
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: FontWeight.Medium,
      margin: 'auto',
      marginBottom: '32px',
      color: 'var(--x-text-color-2)',
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: '40px',
      },
    },
  }),
  {
    name: 'hero-banner-content',
  },
);

export default useStyles;
